import logger from '%app/js/common/services/Logger';
import hasCookieCategoryConsent from '%paysera_service_agreement/js/CookiesUserAgreement/service/hasCookieCategoryConsent';
import { CATEGORY_STATISTICS } from '%paysera_service_agreement/js/CookiesUserAgreement/config/constants';
import sanitizePostHogProperties from './sanitizePostHogProperties';
import { notifyPostHogReady } from './postHogReadyNotifier';

/* eslint-disable babel/camelcase -- posthog-js SDK config keys are snake_case (external API) */
const MASKED_AUTOCAPTURE_OPTIONS = {
    autocapture: true,
    capture_pageview: true,
    mask_all_text: true,
    mask_all_element_attributes: true,
};

const CAPTURE_DISABLED_UNTIL_OPT_IN_OPTIONS = {
    opt_out_capturing_by_default: true,
};

const IDENTIFIER_FREE_PERSISTENCE_OPTIONS = {
    opt_out_persistence_by_default: true,
};

const REMOTELY_TOGGLED_SURFACES_DISABLED_OPTIONS = {
    disable_session_recording: true,
    capture_heatmaps: false,
    disable_surveys: true,
    capture_performance: false,
};

const URL_TOKEN_SUPPRESSION_OPTIONS = {
    save_referrer: false,
    store_google: false,
};

const POSTHOG_INIT_OPTIONS = {
    ...MASKED_AUTOCAPTURE_OPTIONS,
    ...CAPTURE_DISABLED_UNTIL_OPT_IN_OPTIONS,
    ...IDENTIFIER_FREE_PERSISTENCE_OPTIONS,
    ...REMOTELY_TOGGLED_SURFACES_DISABLED_OPTIONS,
    ...URL_TOKEN_SUPPRESSION_OPTIONS,
};
/* eslint-enable babel/camelcase */

const POSTHOG_SUPER_PROPERTIES = { product: 'tickets' };

let postHogModulePromise = null;

const loadPostHog = () => {
    if (postHogModulePromise === null) {
        postHogModulePromise = import('posthog-js')
            .then(module => module.default)
            .catch((error) => {
                postHogModulePromise = null;

                throw error;
            });
    }

    return postHogModulePromise;
};

const hasStatisticsConsent = () => hasCookieCategoryConsent(CATEGORY_STATISTICS);

const reRegisterSuperPropertiesClearedByReset = () => {
    window.posthog.register(POSTHOG_SUPER_PROPERTIES);
};

const bootstrapPostHog = async ({ posthogEnabled, posthogApiKey, posthogHost }, sanitizeProperties) => {
    if (!posthogEnabled || !posthogApiKey || !posthogHost) {
        return;
    }

    if (!hasStatisticsConsent()) {
        return;
    }

    const posthog = await loadPostHog();

    if (!hasStatisticsConsent()) {
        return;
    }

    if (window.posthog === undefined) {
        /* eslint-disable babel/camelcase -- posthog-js SDK options are snake_case (external API) */
        posthog.init(posthogApiKey, {
            ...POSTHOG_INIT_OPTIONS,
            api_host: posthogHost,
            sanitize_properties: sanitizeProperties,
        });
        /* eslint-enable babel/camelcase */
        window.posthog = posthog;
    }

    reRegisterSuperPropertiesClearedByReset();

    if (window.posthog.has_opted_out_capturing()) {
        window.posthog.opt_in_capturing();
    }

    notifyPostHogReady();
};

const initPostHog = async (appSettings, sanitizeProperties = sanitizePostHogProperties) => {
    try {
        await bootstrapPostHog(appSettings, sanitizeProperties);
    } catch (error) {
        logger.error('initPostHog: PostHog bootstrap failed', { error });
    }
};

export default initPostHog;
